const extensions = {
    excel: 'xlsx',
    pdf: 'pdf'
  }
  
  const mimeTypes = {
    pdf: 'application/pdf',
    excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  }
  
  export function openFile (fileData, fileName, type) {
    const url = window.URL.createObjectURL(new Blob([fileData], { type: mimeTypes[type] }))
    const tab = window.open(url, fileName)
    setTimeout(() => tab.document.getElementsByTagName('head')[0]
      .appendChild(document.createElement('title'))
      .appendChild(document.createTextNode(fileName)), 500)
  }
  
  export function downloadFile (fileData, fileName, type) {
    const url = window.URL.createObjectURL(new Blob([fileData], { type: mimeTypes[type] }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${fileName}.${extensions[type]}`)
    document.body.appendChild(link)
    link.click()
  }
  